import React from 'react';
import { getVisionRequestHistory } from '../../services/api/cashless-vision';
import { LoadingContainer, LoadingIcon } from '../offline-consultations/table-subcomponent/StyledComponents';
import {
  HistoryItem,
  TimeContainer,
  StyledHistoryContainer,
} from '../common/Activities';

export default class HistoryContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      history: [],
    };
  }

  getHistory = (requestId) => {
    return getVisionRequestHistory(requestId)
      .then((response) => {
        console.log(response, 'response')
        if (response && response.message === 'success') {
          return response.data;
        }
        throw new Error('Response Message is not correct');
      })
      .catch((err) => {
        console.error(err, 'Error while fetching data');
      });
  };

  componentDidMount() {
    const { requestId } = this.props;

    this.getHistory(requestId)
      .then((data) => {
        console.log({ data, requestId }, 'History');
        this.setState({
          history: data,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  render() {
    const { history, loading } = this.state;
    return loading ? (
      <LoadingContainer>
        <LoadingIcon></LoadingIcon>
      </LoadingContainer>
    ) : (
      <StyledHistoryContainer
        style={{
          borderRadius: '12px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '5px',
            borderBottom: '1px solid #0000003b',
          }}
        >
          <strong>Statuses</strong>
          <strong>Timings</strong>
        </div>
        {history && history.length > 0 ? (
          history.map((item) => {
            let descriptionContent = item.description;

            return (
              <HistoryItem key={item.activityId}>
                {descriptionContent}
                {item.audioFileLink && (
                  <a href={item.audioFileLink} target="_blank" rel="noopener noreferrer">
                    Link
                  </a>
                )}{' '}
                <TimeContainer>{item.eventTime}</TimeContainer>
              </HistoryItem>
            );
          })
        ) : (
          <HistoryItem>No Activities Here</HistoryItem>
        )}
      </StyledHistoryContainer>
    );
  }
}
